"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var ActualFeeRateResource = /** @class */ (function (_super) {
    tslib_1.__extends(ActualFeeRateResource, _super);
    function ActualFeeRateResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActualFeeRateResource.endpoint = '/actualfeerates';
    ActualFeeRateResource.MODEL_NAME = 'actualfeerate';
    return ActualFeeRateResource;
}(base_1.default));
exports.default = ActualFeeRateResource;
//# sourceMappingURL=actualfeerate.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/actualfeerate.js
// module id = BpVg
// module chunks = 0